import {
  parseContentDispositionFilename,
  payLinksCsvFileName,
  triggerCsvDownload,
} from "@/domain/payLinks/exportPayLinksCsv";
import { http } from "@/lib/http/client";
import type { InvoiceSearchRequest } from "@/types/api";

export async function exportPayLinksCsvFromServer(
  body: InvoiceSearchRequest,
): Promise<{ rowCount: number; filename: string }> {
  const response = await http.post<ArrayBuffer>("/pay-links/export-csv", body, {
    responseType: "arraybuffer",
    headers: { Accept: "text/csv" },
  });
  const disposition = response.headers["content-disposition"];
  const filename =
    parseContentDispositionFilename(
      typeof disposition === "string" ? disposition : undefined,
    ) ?? payLinksCsvFileName();
  triggerCsvDownload(response.data, filename);
  const text = new TextDecoder().decode(response.data);
  const lines = text.trim().split("\n");
  const rowCount = Math.max(0, lines.length - 1);
  return { rowCount, filename };
}
